<template>
  <div>
      <section>
        <h2 id="portfolio">{{titre}}</h2>
        <div class="wrapper">

              <div v-for="imageDeLaListe in listeImages" :key="imageDeLaListe.numero" class="image">   
                        <div class="containerImage">
                             <img :src="require( `@/assets/images/${imageDeLaListe.nomImage}.${imageDeLaListe.extension}`)" class="imagePortfolio" :alt="imageDeLaListe.altTexte">
                                <div class="overlay">
                                    <div class="text" >{{imageDeLaListe.description}}</div>
                                </div>
                        </div>
            </div>      
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'portfolio',
  props: {
    msg: String
  },
    data() {    
      return {

            titre : 'Mon portfolio',
            icon : "1",
            monIndex : 0,
            listeImages: [

                {
                    numero : 1,
                    extension : 'jpg',
                    altTexte : "UEFA",
                    nomImage : "1",
                    description : "Création de pages «responsive» pour l'intranet de l'UEFA - Ergonomie / Coordination avec les découpeurs HTML",
                },

                {
                    numero : 2,
                    extension : 'jpg',
                    altTexte : "Sicpa",
                    nomImage : "2",
                    description : "Sicpa / Maquettes, ergonomie & relooking de l'intranet de Sicpa",
                },

                {
                    numero : 3,
                    extension : 'jpg',
                    altTexte : "UEFA",
                    nomImage : "3",
                    description : "UEFA / Développement d'outils de planification d'événements / Design & ergonomie",
                }, {
                    numero : 4,
                    extension : 'jpg',
                    altTexte : "CE",
                    nomImage : "4",
                    description : "CE / Création de pages responsive de différents sites internet de la Commission Européenne",
                }, {
                    numero : 5,
                    extension : 'jpg',
                    altTexte : "CE",
                    nomImage : "5",
                    description : "Création d'un site internet girly pour promouvoir les études scientifiques des jeunes femmes",
                }, {
                    numero : 6,
                    extension : 'jpg',
                    altTexte : "Schaerbeek",
                    nomImage : "6",
                    description : "Création du site de la commune de Schaerbeek (màj par le client)",
                }, {
                    numero : 7,
                    extension : 'jpg',
                    altTexte : "Nespresso",
                    nomImage : "7",
                    description : "Nespresso / Webdesign de pages d'inscriptions des clients sur smartphone & tablette",
                }, {
                    numero : 8,
                    extension : 'jpg',
                    altTexte : "Live Vote",
                    nomImage : "8",
                    description : "Wireframe & Design Apps pour smartphone",
                }, {
                    numero : 9,
                    extension : 'jpg',
                    altTexte : "CE",
                    nomImage : "9",
                    description : "CE / Conception & storyboards de jeux en Flash / Coordination",
                }, {
                    numero : 10,
                    extension : 'jpg',
                    altTexte : "Natura 2000",
                    nomImage : "10",
                    description : "Natura 2000 / Création de pages responsive pour tablettes et smartphones",
                }, {
                    numero : 11,
                    extension : 'jpg',
                    altTexte : "Seven Lives",
                    nomImage : "11",
                    description : "Seven Lives / Création du site internet de l'événement",
                }, {
                    numero : 12,
                    extension : 'jpg',
                    altTexte : "Huawei",
                    nomImage : "12",
                    description : "Huawei / Maquettes & relooking du site Huawei",
                }, {
                    numero : 13,
                    extension : 'jpg',
                    altTexte : "Médias sociaux",
                    nomImage : "13",
                    description : "Bannières Gif, Flash pour campagnes publicitaires / Newsletter (Huawei, be.brussels, CE ...)",
                }, {
                    numero : 14,
                    extension : 'jpg',
                    altTexte : "AG-Press",
                    nomImage : "14",
                    description : "Création de pages responsive de l'extranet AG-Press",
                }, {
                    numero : 15,
                    extension : 'jpg',
                    altTexte : "Assemblée Nationale",
                    nomImage : "15",
                    description : "Assemblée Nationale / Conception & ergonomie des pages du président et des députés",
                }, {
                    numero : 16,
                    extension : 'jpg',
                    altTexte : "CE",
                    nomImage : "16",
                    description : "CE / Création du site internet de l'événement (A.O.)",
                }, {
                    numero : 17,
                    extension : 'jpg',
                    altTexte : "Développement web front-end",
                    nomImage : "17",
                    description : "Développement web front-end & Design",
                }, {
                    numero : 18,
                    extension : 'jpg',
                    altTexte : "Prestashop",
                    nomImage : "18",
                    description : "e-Commerce / Front & Back Office sous Prestashop / Photographie des objets",
                }, {
                    numero : 19,
                    extension : 'jpg',
                    altTexte : "Conception de logos",
                    nomImage : "19",
                    description : "Recherches graphiques & conception de logos",
                }, {
                    numero : 20,
                    extension : 'jpg',
                    altTexte : "Conception de logos",
                    nomImage : "20",
                    description : "Recherches graphiques & conception de logos",
                }, {
                    numero : 21,
                    extension : 'jpg',
                    altTexte : "Conception de logos",
                    nomImage : "21",
                    description : "Recherches graphiques & conception de logos",
                }, {
                    numero : 22,
                    extension : 'jpg',
                    altTexte : "Conception de logos",
                    nomImage : "22",
                    description : "Création de logotypes",
                }, {
                    numero : 23,
                    extension : 'jpg',
                    altTexte : "Conception de logos",
                    nomImage : "23",
                    description : "Recherches graphiques & conception de logos",
                }, {
                    numero : 24,
                    extension : 'jpg',
                    altTexte : "Conception de logos",
                    nomImage : "24",
                    description : "Conception de logos",
                }, {
                    numero : 25,
                    extension : 'jpg',
                    altTexte : "Conception de logos",
                    nomImage : "25",
                    description : "Plateforme de l'UE relative à l'alimentation, l'activité physique et la santé / Création du logotype",
                },
                {
                    numero : 26,
                    extension : 'jpg',
                    altTexte : "EDF",
                    nomImage : "26",
                    description : "EDF / Création de visuels (Presse & Banners Web)",
                }, {
                    numero : 27,
                    extension : 'jpg',
                    altTexte : "Huawei",
                    nomImage : "27",
                    description : "Huawei / Encarts publicitaires presse",
                }, {
                    numero : 28,
                    extension : 'jpg',
                    altTexte : "ShiftMag",
                    nomImage : "28",
                    description : "ShiftMag / Création et montages visuels pour différents magazines",
                }, {
                    numero : 29,
                    extension : 'jpg',
                    altTexte : "Sivana",
                    nomImage : "29",
                    description : "Sivana / Recherches graphiques & conception de logos",
                }, {
                    numero : 30,
                    extension : 'jpg',
                    altTexte : "Création de logos",
                    nomImage : "30",
                    description : "Création de logos",
                }, {
                    numero : 31,
                    extension : 'jpg',
                    altTexte : "Conception 3D",
                    nomImage : "31",
                    description : "Maquettes et créations de stands 3D pour différents événements (CE)",
                }, {
                    numero : 32,
                    extension : 'jpg',
                    altTexte : "Conception 3D",
                    nomImage : "32",
                    description : "Maquettes et créations de stands 3D pour différents événements (CE)",
                }, {
                    numero : 33,
                    extension : 'jpg',
                    altTexte : "Développement web front-end & Design",
                    nomImage : "33",
                    description : "Développement web front-end & Design",
                }, {
                    numero : 34,
                    extension : 'jpg',
                    altTexte : "Création de logos",
                    nomImage : "34",
                    description : "Création de logos",
                }, {
                    numero : 35,
                    extension : 'jpg',
                    altTexte : "3D",
                    nomImage : "35",
                    description : "3D SketchUp pour la menuiserie",
                }, {
                    numero : 36,
                    extension : 'jpg',
                    altTexte : "3D",
                    nomImage : "36",
                    description : "3D SketchUp pour la menuiserie",
                },
                {
                    numero : 37,
                    extension : 'jpg',
                    altTexte : "3D",
                    nomImage : "37",
                    description : "3D SketchUp pour la menuiserie",
                },
                {
                    numero : 38,
                    extension : 'jpg',
                    altTexte : "Jeux Javascript",
                    nomImage : "38",
                    description : "Quiz en Javascript (hamsterquiz.com)",
                },
                {
                    numero : 39,
                    extension : 'jpg',
                    altTexte : "Conception Powerpoint",
                    nomImage : "39",
                    description : "Conception de présentations Powerpoint (goSlide.be)",
                },
                {
                    numero : 40,
                    extension : 'jpg',
                    altTexte : "Médias sociaux",
                    nomImage : "40",
                    description : "Conception d'images pour les médias sociaux",
                },
                {
                    numero : 41,
                    extension : 'jpg',
                    altTexte : "Médias sociaux",
                    nomImage : "41",
                    description : "Conception d'images pour les médias sociaux",
                },
                {
                    numero : 42,
                    extension : 'jpg',
                    altTexte : "Conception de logos",
                    nomImage : "42",
                    description : "Conception de logos",
                },
                {
                    numero : 43,
                    extension : 'jpg',
                    altTexte : "Médias sociaux",
                    nomImage : "43",
                    description : "Conception d'images pour les médias sociaux",
                },
                {
                    numero : 44,
                    extension : 'jpg',
                    altTexte : "Médias sociaux",
                    nomImage : "44",
                    description : "Conception d'images pour les médias sociaux",
                },
                {
                    numero : 45,
                    extension : 'jpg',
                    altTexte : "Médias sociaux",
                    nomImage : "45",
                    description : "Conception d'images pour les médias sociaux",
                },
                {
                    numero : 46,
                    extension : 'jpg',
                    altTexte : "Médias sociaux",
                    nomImage : "46",
                    description : "Conception d'images pour les médias sociaux",
                },
                {
                    numero : 47,
                    extension : 'jpg',
                    altTexte : "Médias sociaux",
                    nomImage : "47",
                    description : "Conception d'images pour les médias sociaux",
                },
                {
                    numero : 48,
                    extension : 'jpg',
                    altTexte : "Photographie",
                    nomImage : "48",
                    description : "Galerie de photos",
                },         

                    ]   
        }  
        },
            computed : {
					texteImageHover(){
                    return this.listeImages[this.monIndex].numero        
                    }
            }
}
</script>

<style scoped>
/* version Full */

.image img {
  width: 100%;
}

.wrapper {
  margin: 0 20px 0 20px;
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-areas:
    "image  image  image image"
    "image  image  image image"
    "image  image  image image"
    "image  image  image image"
    "image  image  image image"
    "image  image  image image"
    "image  image  image image"
    "image  image  image image"
    "image  image  image image"
    "image  image  image image";
}


/* Fin version Full */

#portfolio {
color: #306ea3;
}

/*  OVERLAY */
.containerImage {
  position: relative;
  width: 100%;
  height: 100%;
}

.imagePortfolio {
  display: block;
  width: 100%;
  height: auto;
}

.overlay {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background-color: #008CBA;
  overflow: hidden;
  width: 100%;
  height: 0;
  transition: .5s ease;
  opacity: 0.95;
}

.containerImage:hover .overlay {
  bottom: 0;
  height: 100%;
  cursor: crosshair;
}

.text {
  color: white;
  line-height: 18px;
  font-size: 18px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
  text-shadow: 0px -1px 0px rgba(28, 27, 36, 0.95);
}

.pointer {
  cursor: crosshair;
}


/* --------------------------------- 1024 px  */
@media only screen and (max-width: 1024px) {

  .wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image"
      "image  image";
  }

}

/* --------------------------------- 640px  */
@media only screen and (max-width: 640px) {
    .wrapper{
    display: block;
    }

    .image img {
    margin: 10px 0;
}

}

</style>



